export default __webpack_public_path__ + "static/media/logo-text.78f0801d.svg";